import { render } from "./SnehaSparshamInterviewList.vue?vue&type=template&id=3e6d5716&scoped=true"
import script from "./SnehaSparshamInterviewList.vue?vue&type=script&lang=js"
export * from "./SnehaSparshamInterviewList.vue?vue&type=script&lang=js"

import "./SnehaSparshamInterviewList.vue?vue&type=style&index=0&id=3e6d5716&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6d5716"]])

export default __exports__